import {
  createStyles,
  IconButton,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { X } from 'react-feather';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit/src/';

interface Props {
  classes?: any;
  className?: any;
  onClose: () => void;
  size?: number;
  label?: string;
  ariaLabel?: string;
}

export const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
  })
);

const CloseButton = ({
  classes,
  className,
  size,
  onClose,
  label,
  ariaLabel,
}: Props) => {
  const classesTheme = useStyles();
  const iconClass = classes
    ? clsx(classes.listActionIcon, classes.closeGroupPanel, classesTheme.icon)
    : clsx(className, classesTheme.icon);
  return (
    <Tooltip
      classes={{
        tooltip: classes && classes.tooltip,
      }}
      enterDelay={500}
      placement="top"
      title={label || 'Close'}
    >
      <IconButton
        onClick={onClose}
        className={iconClass}
        aria-label={ariaLabel ?? 'Decline'}
      >
        <X size={size} />
      </IconButton>
    </Tooltip>
  );
};

export default CloseButton;
